export enum FolderType {
  Judiciary = 'judiciary',
  Private = 'private',
  UTP = 'utp',
  NPL = 'npl',
}
